import { ApiProperty } from '@nestjs/swagger';

export class VdPdfTraficoItemDto {
  @ApiProperty({ example: 'FAR EAST' })
  trafico!: string;

  @ApiProperty({ example: 99 })
  porcentaje!: number;

  @ApiProperty({ example: 74 })
  contenedores!: number;
}

export class LiquidacionVdPdfPageTraficoDto {
  @ApiProperty({ example: 75 })
  totalContenedores!: number;

  @ApiProperty({ type: [VdPdfTraficoItemDto] })
  items!: VdPdfTraficoItemDto[];
}
